exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drawer-content[data-v-d8c3231c] {\n  height: calc(100vh - 120px);\n  overflow-y: auto;\n  padding: 0 24px 80px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.drawer-footer[data-v-d8c3231c] {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 14px 24px;\n  text-align: right;\n  background: #fff;\n  border-top: 1px solid #ebeef5;\n}\n.tip[data-v-d8c3231c] {\n  color: #909399;\n  font-size: 12px;\n  line-height: 20px;\n}\n.switch-tip[data-v-d8c3231c] {\n  margin-left: 12px;\n}\n.mb20[data-v-d8c3231c] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
